exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sidebar-menu .sub-menu li.mm-active>a,#sidebar-menu .sub-menu li a.active,#sidebar-menu .sub-menu li a.side-nav-link-ref.active,#sidebar-menu li a.side-nav-link-ref.active,#sidebar-menu ul li.mm-active>a{color:#cb9700!important}", ""]);

// exports
